"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledOverlay = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledOverlay = styled_components_1.default.div `
  background-color: ${({ isWhite, theme }) => isWhite ? theme.colors.colours.overlay.white[50].value : theme.colors.colours.overlay['digital-black'][50].value};
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${({ zIndex }) => zIndex};
`;
//# sourceMappingURL=Overlay.styled.js.map